export const LOGALTY_EVENT_CODES = {
    SIGNING_SUCCESSFUL: '7',
    GENERIC_ERROR: '-1',
    PIN_KO: '99904',
    SESSION_EXPIRED: '99906',
    GENERIC_ERROR_TEXT: 'genericError',
};
